import { render, staticRenderFns } from "./person-add.vue?vue&type=template&id=fc9e8944"
import script from "./person-add.vue?vue&type=script&lang=js"
export * from "./person-add.vue?vue&type=script&lang=js"
import style0 from "./person-add.vue?vue&type=style&index=0&id=fc9e8944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports